import {
  createFormHook,
  createFormHookContexts,
  formOptions as createFormOptions,
} from "@tanstack/react-form";
import { log } from "./log";

export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts();

export const formOptions = createFormOptions({
  onSubmitInvalid: (errors: unknown) => {
    type FormError = {
      formApi: { getAllErrors: () => unknown };
    };

    const isFormError =
      typeof errors === "object" &&
      errors !== null &&
      "formApi" in errors &&
      typeof (errors as FormError).formApi?.getAllErrors === "function";

    const formErrors = isFormError
      ? (errors as FormError).formApi.getAllErrors()
      : errors;

    log(
      { message: "Form submission errors", errors: formErrors },
      { level: "warning" },
    );

    return errors;
  },
});

export const { withForm, useAppForm: useForm } = createFormHook({
  formContext,
  fieldContext,
  formComponents: {},
  fieldComponents: {},
});

export function isFieldInvalid(field: unknown) {
  const typedField = field as {
    state: { meta: { isTouched: boolean; isValid: boolean } };
  };
  return Boolean(
    typedField?.state?.meta?.isTouched && !typedField?.state?.meta?.isValid,
  );
}
